import React, { useState } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  TableContainer,
  Paper,
} from "@mui/material";
import {
  GridContainer,
  HoldingsTableContainer,
  HoldingsTable,
  HoldingsTableRow,
  HoldingsTableHeader,
  DataCardTitle,
  DataCardHeader,
  GridItem,
} from "./PeriodicIso.styles";
import DevicesIcon from "@mui/icons-material/Devices";

function RenderTerminalRow(props) {
  const { row } = props;
  const [open, setOpen] = useState(false);

  const formatNumber = (value) => {
    if (typeof value === "string") {
      const num = parseFloat(value);
      return isNaN(num)
        ? value
        : num.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          });
    }
    return value?.toLocaleString("en-US") || "0";
  };

  const isPositiveAmount = (value) => {
    const num = parseFloat(value);
    return !isNaN(num) && num >= 0;
  };

  return (
    <>
      <HoldingsTableRow isOpen={open}>
        <TableCell align="right" sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
          {row?.terminalID}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          {row?.exchangeName || "N/A"}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          ${formatNumber(row?.transactionsAmount)}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          {row?.transactionsCount}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            fontWeight: 700,
            fontSize: "0.875rem",
            color: isPositiveAmount(row?.amountDue)
              ? "success.main"
              : "error.main",
          }}
        >
          ${formatNumber(row?.amountDue)}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          ${formatNumber(row?.txMDR)}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          ${formatNumber(row?.txProcessing)}
        </TableCell>
      </HoldingsTableRow>
    </>
  );
}

const TerminalsTable = (props) => {
  const { terminalList } = props;

  const headers = [
    { label: "Terminal ID", align: "center" },
    { label: "Exchange Name", align: "center" },
    { label: "Trans. Amount", align: "center" },
    { label: "Trans. Count", align: "center" },
    { label: "Settlement", align: "center" },
    { label: "MDR Fee", align: "center" },
    { label: "Proc. Fee", align: "center" },
  ];

  return (
    <GridContainer>
      <GridItem xs={12}>
        <DataCardHeader>
          <DevicesIcon color="primary" />
          <DataCardTitle>Terminals</DataCardTitle>
        </DataCardHeader>
      </GridItem>
      <HoldingsTableContainer sx={{ width: "100%" }}>
        <TableContainer component={Paper} elevation={0} sx={{ width: "100%" }}>
          <HoldingsTable size="small" sx={{ width: "100%" }}>
            <HoldingsTableHeader>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell
                    key={index}
                    align={header.align}
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.875rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      ...header.style,
                    }}
                  >
                    {header.label}
                  </TableCell>
                ))}
              </TableRow>
            </HoldingsTableHeader>
            <TableBody>
              {terminalList && terminalList.length > 0 ? (
                terminalList.map((terminal, index) => (
                  <RenderTerminalRow
                    key={`terminal-${terminal.terminalID} - ${index}`}
                    row={terminal}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                      No Terminals data available
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </HoldingsTable>
        </TableContainer>
      </HoldingsTableContainer>
    </GridContainer>
  );
};

export default TerminalsTable;
